import(/* webpackMode: "eager", webpackExports: ["LocalBuzzMarketsExplorer"] */ "/vercel/path0/app/components/local-buzz/LocalBuzzExplorers.tsx");
